// import firebase from 'firebase/app'; //removed the @ from the start of the path.
import firebase from 'firebase';
import 'firebase/firestore'; //removed the @ from the start of the path
import '@firebase/auth';

firebase.initializeApp({
  apiKey: 'AIzaSyB6ZCkhQz7V9uSZ77g1eoWFEmN2PK5Sv40',
  authDomain: 'timecardapp-87874.firebaseapp.com',
  databaseURL: 'https://timecardapp-87874.firebaseio.com',
  projectId: 'timecardapp-87874',
  storageBucket: 'timecardapp-87874.appspot.com',
  messagingSenderId: '995402842362',
  appId: '1:995402842362:web:a2a8dc2deea663e4b48943',
  measurementId: 'G-ZP2SH8KNTH'
});

const temp_db = firebase.firestore();

//if we are running on localhost, then we will be using the emulator db.
// if (location.hostname === "localhost") {
// firebase.firestore().useEmulator('localhost', 8080)
// firebase.firestore().settings({
//   host: "localhost:8080",
//   ssl: false
// });
// }

export const db = temp_db;
export const auth = firebase.auth();
export const storage = firebase.storage();

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore;
export { Timestamp, GeoPoint };
